<template>

    <div class="box-typical-form" >
        <form v-on:submit="submit">
            <div class="form-group">
                <label for="status_select" class="col-form-label w-100">New Status</label>
                <!-- <select v-model="status" class=""> -->
                <!--     <option selected disabled value="">-- None --</option> -->
                <!--     <option v-for="value, index in statusOptions" :value="value" :key="index">{{value}}</option> -->
                <!-- </select> -->
                <custom-radio-component
                    v-model="status"
                    :values="statusOptions"
                    ></custom-radio-component>
            </div>
            <div class="form-group">
                <label for="comment_textarea" class="col-form-label">Comment</label>
                <textarea v-model="comment" class="form-control textarea mb-2" id="comment_textarea"></textarea>
                <template>
                    <div class="row">
                        <div class="col">
                            <label v-if="sendEmail" class="col-form-label">Send this status update to customer email</label>
                            <div v-if="sendEmail" class="switch-cont">
                                <custom-switch-component
                                    v-model="email_sent"
                                    ></custom-switch-component>
                            </div>
                        </div>
                        <div class="col">
                            <button v-if="loading" disabed
                                class="btn btn-default btn-rounded btn-sm float-right capitalize mt-2">Updating...</button>
                            <button v-else type="submit" :disabled="!status"
                                class="btn btn-primary btn-rounded btn-sm float-right capitalize mt-2">Update Status</button>
                        </div>
                    </div>
                </template>
            </div>
            <div class="form-group">
                <div class="col-sm-12">
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import Vue from 'vue';
import Vuex from 'vuex';
import CustomRadioComponent from '../form-elements/CustomFlavorRadioComponent';
import CustomSwitchComponent from '../form-elements/CustomSwitchComponent';

export default {
    data() {
        return {
            status: this.getLatestStatus(),
            comment: '',
            email_sent: false,
        }
    },

    props: ['type', 'items', 'schema', 'loading', 'config'],

    components: {
        CustomRadioComponent,
        CustomSwitchComponent,
    },

    watch: {
        items(newVal) {
            if (!_.isEmpty(newVal)) {
                this.addNotification({
                    type: 'message',
                    message: 'Status updated successfully',
                });
            }
        }
    },

    computed: {
        statusOptions() {
            const statusFormatter = _.get(this.config, 'statusFormatter');
            let values = _.get(this.config, 'fields.status.values') || _.get(this.schema, 'status.values');

            if (_.isFunction(statusFormatter)) {
                values = _.map(values, statusFormatter);
            }

            return values;
        },

        sendEmail() {
            return _.get(this.config, 'sendEmail');
        },
    },

    methods: {
        ...Vuex.mapActions(['addNotification']),

        submit(e) {
            e.preventDefault();
            if (this.loading) return;

            this.$emit('input', {
                status: this.status,
                comment: this.comment,
                email_sent: this.email_sent,
            });
        },

        getLatestStatus() {
            return _.chain(this.items)
                .sortBy(['meta.created_at'])
                .last()
                .get('attributes.status')
                .value();
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/InlineStatusComponent.vue